<!--==============================
=            CHARTICK            =
===============================-->

<template>
  <!-- CHARTJS -->
  <!-- APEXCHARTS -->
  <v-container>
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">Chartkick</div>
      </base-header>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="6">
        <base-card class="pa-2">
          <div slot="card-header">Collumn</div>
          <div slot="card-body">
            <column-chart
              :data="[
                ['Sun', 32],
                ['Mon', 46],
                ['Tue', 28]
              ]"
            ></column-chart>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" md="6">
        <base-card class="pa-2">
          <div slot="card-header">Bar</div>
          <div slot="card-body">
            <bar-chart
              :data="[
                ['X-Small', 5],
                ['Small', 27]
              ]"
            ></bar-chart>
          </div>
        </base-card>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="6">
        <base-card class="pa-2">
          <div slot="card-header">Area</div>
          <div slot="card-body">
            <area-chart
              :data="{
                '2017-01-01 00:00:00 -0800': 2,
                '2017-01-01 00:01:00 -0800': 5
              }"
            >
            </area-chart>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" md="6">
        <base-card class="pa-2">
          <div slot="card-header">Generic Gradient</div>
          <div slot="card-body">
            <scatter-chart
              :data="[
                [174.0, 80.0],
                [176.5, 82.3]
              ]"
              xtitle="Size"
              ytitle="Population"
            >
            </scatter-chart>
          </div>
        </base-card>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="6">
        <base-card class="pa-2">
          <div slot="card-header">Sales Top</div>
          <div slot="card-body">
            <line-chart :data="data" />
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" md="6">
        <base-card class="pa-2">
          <div slot="card-header">Generic Gradient</div>
          <div slot="card-body">
            <line-chart :data="chartData"></line-chart>
          </div>
        </base-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
export default {
  components: {
    BaseCard,
    BaseHeader
  },
  data() {
    return {
      chartData: [
        ["Jan", 4],
        ["Feb", 2],
        ["Mar", 10],
        ["Apr", 5],
        ["May", 3]
      ],
      data: [
        {
          name: "Workout",
          data: {
            "2017-01-01 00:00:00 -0800": 3,
            "2017-01-02 00:00:00 -0800": 4
          }
        },
        {
          name: "Call parents",
          data: {
            "2017-01-01 00:00:00 -0800": 5,
            "2017-01-02 00:00:00 -0800": 3
          }
        }
      ]
    };
  }
};
</script>

<!--====  End of CHARTICK  ====-->
